import { render } from "./linkProfile.vue?vue&type=template&id=5335a573"
import script from "./linkProfile.vue?vue&type=script&lang=js"
export * from "./linkProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__